var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarnIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#FFF4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6665 30.4993H27.3332V33.166H24.6665V30.4993ZM24.6665 19.8327H27.3332V27.8327H24.6665V19.8327ZM25.9865 13.166C18.6265 13.166 12.6665 19.1393 12.6665 26.4993C12.6665 33.8594 18.6265 39.8327 25.9865 39.8327C33.3598 39.8327 39.3332 33.8594 39.3332 26.4993C39.3332 19.1393 33.3598 13.166 25.9865 13.166ZM25.9998 37.166C20.1065 37.166 15.3332 32.3927 15.3332 26.4993C15.3332 20.606 20.1065 15.8327 25.9998 15.8327C31.8932 15.8327 36.6665 20.606 36.6665 26.4993C36.6665 32.3927 31.8932 37.166 25.9998 37.166Z",
    fill: "#9E6221"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnIcon2);
export default __webpack_public_path__ + "static/media/warnIcon2.21d494ebc094fa00571bb6478490bd68.svg";
export { ForwardRef as ReactComponent };